// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2M5SB","title":"AfterBackImages_title__3lJa4","images":"AfterBackImages_images__2sw_I"};